import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Spinner = ({ toggleValue, props: { parentDiv, spinnerIcon } }) => {
    useEffect(() => {
        if (toggleValue) {
            document.body.style.overflow = "hidden";
        }
        return () => {
            document.body.style.overflow = "unset";
        };
    }, []);
    return (
        <div className={parentDiv?.className} style={parentDiv.style}>
            <div className={spinnerIcon?.className}></div>
        </div>
    );
};
export default Spinner;
